import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import InventoryFilterCriteria from './InventoryFilterCriteria'
import InventoryList from './InventoryList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './InventoryAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setInventoryDashboardInventoryList } from '../../store/slice/ManufSlice';

export default function InventoryListView({setShowEdit,setInventoryId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.inventoryDashboard);   

    const [filteredInventoryList, setFilteredInventoryList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { inventoryDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (inventoryDashboard.inventoryList.length>-1){
        setFilteredInventoryList(inventoryDashboard.inventoryList);
        transformToCardFormat(inventoryDashboard.inventoryList, setCardList);
      }
    },[inventoryDashboard.inventoryList])

    useEffect(()=>{
          transformToCardFormat(filteredInventoryList, setCardList);
      },[filteredInventoryList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.productid==='' && filterCriteria.productname==='' && filterCriteria.itemcount==='' && filterCriteria.orderid==='' && filterCriteria.productorderid==='' && filterCriteria.credititemid==='' ){
            setFilteredInventoryList(inventoryDashboard.inventoryList);
            transformToCardFormat(inventoryDashboard.inventoryList, setCardList);

        } else {
            setFilteredInventoryList(
                inventoryDashboard.inventoryList
                    .filter(inventory=> inventory.productname.toString().toUpperCase().includes(filterCriteria.productname.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(inventoryDashboard.filteredInventoryList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <InventoryList
                    setShowEdit={setShowEdit}
                    setInventoryId = {setInventoryId}
                    tableList={filteredInventoryList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}